// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1WcPW","right":"styles_right__2yI30"};